  //=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

function manageStartupAccountsAPI() {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/manage-startup-accounts?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function searchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/manage-startup-accounts/search?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


  async function exportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/manage-startup-accounts/export`, obj);

      return handleResponse(res);

    } catch (err) {
      handleError(err);

    }
  }
  async function updateAutoRedeemConfig(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/manage-startup-accounts/auto-redeem`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  
  return {
    getAPI,
    searchAPI,
    exportAPI,
    updateAutoRedeemConfig
  };
}

export default manageStartupAccountsAPI;
